import { VFC } from 'react';
import styled from 'styled-components';
import { CSVLink } from 'react-csv';

import { Pagination } from 'ui/pagination';
import { PageSize } from 'ui/pageSize';
import { TableHeader, TableHeaderProps } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { pxToRem } from 'utils/convert';

import { ExtendedEventInfo } from '../types';

/*
  Event summary table
*/
export const TableWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.values.double};
`;

export const StyledHeader = styled(
  TableHeader as VFC<TableHeaderProps<string & keyof ExtendedEventInfo>>,
)`
  height: ${({ theme }) => theme.spacing.values.x3};
  > div {
    padding: ${({ theme }) =>
      `${theme.spacing.values.threeQuarter} ${theme.spacing.values.plusHalf}`};
    border-top: ${({ theme }) => `${theme.spacing.values.single} #bdbdbd solid`};
    border-bottom: ${({ theme }) => `${theme.spacing.values.single} #bdbdbd solid`};
  }
  > div:not(:first-child) > div {
    justify-content: flex-end;
    padding-right: ${pxToRem(88)};
  }
  > div:first-child {
    padding-left: ${({ theme }) => theme.spacing.values.plusHalf};
  }
  // sorting arrow
  > div > div > svg {
    margin-left: ${({ theme }) => theme.spacing.values.half};
  }
`;

export const StyledRows = styled(TableRows)`
  ${({ theme }) => theme.styles.body.body2};
  > div:not(:first-child) {
    padding-right: ${({ theme }) => theme.spacing.values.x7};
  }
  > div:nth-child(2) > div {
    text-align: right;
    margin-right: ${({ theme }) => theme.spacing.values.quarter};
  }
`;

/*
  Pagination / Table footer
*/
export const TableFooter = styled.div`
  ${({ theme }) => theme.styles.body.body2};
  display: flex;
  flex-direction: horizontal;
  justify-content: space-between;
  height: ${({ theme }) => theme.spacing.values.x6};
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  border-top: ${({ theme }) => `${theme.spacing.values.single} #bdbdbd solid`};
`;

export const TotalEvents = styled.div`
  display: flex;
  align-items: center;
  padding-left: ${({ theme }) => theme.spacing.values.plusHalf};
`;

export const StyledPagination = styled(Pagination)`
  padding-right: 40px;
`;

export const StyledPageSize = styled(PageSize)`
  display: flex;
  align-items: center;
  padding-right: ${({ theme }) => theme.spacing.values.plusHalf};
`;

/*
  Table CSV Export 
*/
export const HiddenCSVLink = styled(CSVLink)`
  display: none;
`;

/*
  Loading states
*/
export const StyledLoadingRows = styled(TableRows)`
  > div:not(:first-child) {
    padding-right: ${({ theme }) => theme.spacing.values.double};
  }
  > div:last-child {
    padding-left: ${({ theme }) => theme.spacing.values.x3};
  }
`;

/*
 Empty state
*/

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.values.single};
  margin-bottom: ${({ theme }) => theme.spacing.values.x3};
  padding: ${({ theme }) => theme.spacing.values.x10} 0;
`;

export const EmptyStateTitle = styled.div`
  ${({ theme }) => theme.styles.headings.heading4};
  margin-top: ${({ theme }) => theme.spacing.values.base};
`;

export const EmptyStateDescription = styled.div`
  ${({ theme }) => theme.styles.body.body1};
  margin-top: ${({ theme }) => theme.spacing.values.half};
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  width: ${pxToRem(462)};
  text-align: center;
`;
